// TEMPORARY COMPONENT DURING FRONTIER DOMAIN MIGRATION
// Ticket tracking removal when domain migration is complete: https://jira.kbobjects.com/browse/KIIP-744
import React from "react";
import { Alert, Button } from "@amzn/awsui-components-react-v3/polaris";

export const IdentityPortalToAlternativeAuthDomainMap: Record<string, string> =
  {
    "identity.astro.kpo.amazon": "auth.frontier.amazon",
    "final.frontier.amazon": "auth.astro.kpo.amazon",
  };

/**
 * Builds a registration link for the given Frontier Auth domain, embedding the user's alias as a query parameter.
 * @param domain - The Frontier Auth domain to build the link for (e.g. "auth.frontier.amazon")
 * @param alias - The user's alias to include in the link. This is necessary in case the user has never logged in to
 * the alternate domain before and would not have their alias already set in local storage on the login page.
 * @returns The full registration URL with the alias and domain embedded
 */
export const buildDomainRegistrationLink = (domain: string, alias: string) =>
  `https://${domain}/login?federation=1&rp=a5b79f53-1e44-4f35-ba06-3c22585677a1&alias=${encodeURIComponent(alias)}&next=/register/auto`;

export interface AlternativeDomainRegistrationAlertProps {
  alias?: string;
  hostname?: string;
}

export const AlternativeDomainRegistrationAlert = ({
  alias,
  hostname = window.location.hostname,
}: AlternativeDomainRegistrationAlertProps) => {
  const altDomain = IdentityPortalToAlternativeAuthDomainMap[hostname];
  if (!altDomain) return null;

  const altDomainRegistrationLink = buildDomainRegistrationLink(
    altDomain,
    alias ?? "",
  );

  return (
    <Alert
      type="info"
      header="Frontier Auth is changing domain names"
      action={
        <Button
          href={altDomainRegistrationLink}
          target="_blank"
          iconName="external"
        >
          Register on {altDomain}
        </Button>
      }
    >
      If you have not done so already, we recommend registering this same
      security key again on our other domain to ensure you have access to all of
      your Leo resources during and after the migration.
    </Alert>
  );
};
